export default __webpack_public_path__ + "static/media/svgBack.b41760f6.svg";